// PPE 2.0 (DEV-4849 wave 3): client for the per-company Freddie feed connection config
// (FreddieConnectionController) — the GsePricingFreddie* company properties (seller ids, expected
// products/pool buckets/servicer ids, enabled price types). Supersedes the wave-1 GseSmaSettingsApi
// stub. Every call skips the global forbidden-reload: GET degrades to the seed defaults, and the WRITE
// surfaces a 403 inline via the thunk mutation-error slice.
import { SKIP_FORBIDDEN } from './httpConfig';

export class FreddieConnectionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getConnection() {
    return this.#http.get('/api/freddie-connection', SKIP_FORBIDDEN);
  }

  async updateConnection(body) {
    return this.#http.put('/api/freddie-connection', body, SKIP_FORBIDDEN);
  }
}
